function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconOpenExternalFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25 27H5V7h8V5H5a2 2 0 00-2 2v20a2 2 0 002 2h20a2 2 0 002-2v-8h-2v8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3v2h7.586L13 17.586 14.415 19 27 6.414V14h2V3H18z",
    fill: props.color
  }));
}

export default SvgIconOpenExternalFilled;